import * as moment from "moment";
import VerbConstants from "motw_core/Constants/VerbConstants";
import {
    GetEntryPrefix,
    SaveLogEntryAsync
} from "motw_core/Repositories/LogEntryRepository";
import { HandleError } from "source/app/presentation/Shared/HandleError";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import {
    OnErrorAddLogEntry,
    OnFinishAddLogEntry
} from "source/app/services/Log/AddEntry";


export async function PostBookOfMindPointAsync() {
    try {
        const verb = "Realizing";
        const entrySymbol = VerbConstants.GetSymbol(verb);

        const logEntry = [
            GetEntryPrefix(0, entrySymbol) +
            " " +
            verb +
            " new book of mind quote 1",
            "1",
            "9",
            moment().format("MMM D YYYY HH:mm"),
            "1", // Set energy value to default because its not being used
        ];

        await SaveLogEntryAsync(
            logEntry,
            ClientDataProvider,
            true,
            OnErrorAddLogEntry,
            OnFinishAddLogEntry
        );
    } catch (e) {
        HandleError(e);
    }
}
